import { accents, purples } from './colors'
import baseTheme from './light'

const background = 'oklch(21.41% 0.001 2.4)'

const dark = {
  ...baseTheme,
  boxShadow: {
    shallow: '0px 3px 2px rgba(28, 28, 44, 0.06), 0px 2px 15px rgba(28, 28, 44, 0.07)',
    medium: '0px 10px 8px rgba(0, 0, 0, 0.06), 0px 8px 45px rgba(0, 0, 0, 0.07)',
    deep: '0px 10px 8px rgba(28, 28, 44, 0.06), 0px 30px 30px rgba(28, 28, 44, 0.07), 0px 70px 65px rgba(28, 28, 44, 0.09)',
  },
  colors: {
    ...baseTheme.colors,

    'background': background,
    'background-primary': 'oklch(28.82% 0.002 2.4);',
    'background-alt': accents.accent2,
    'background-hover': '#24262c',
    'input-background': accents.accent2,
    'suggested-background': 'rgb(39 30 50)',

    'badge-bg': accents.accent2,
    'scrollbar-bg': accents.accent3,
    'readonly-text-bg': '#181818',

    'text': accents.accent7,
    'text-secondary': accents.accent5,
    'link-secondary': accents.accent7,

    'border-color-light': accents.accent2,
    'border-color': 'hsl(221 0% 27%)',

    'pill-bg': accents.accent4,
    'warning-tag-text': 'rgba(222, 162, 0, 1)',

    'search-background': accents.accent2,
    'search-background-focus': accents.accent3,
    'search-text-color': accents.accent7,
    'search-text-placeholder-color': accents.accent6,

    'option-hover-bg': accents.accent2,

    'primary': purples.purple6,

    'menu': accents.accent1,
    'menu-item-hover-bg': accents.accent2,
    'menu-item-hover-color': accents.accent7,

    /**
     * Pills
     */

    'pill-default-bg': 'rgba(255, 255, 255, .15)',
    'pill-default-color': accents.accent7,

    'pill-warning-bg': 'rgba(253, 211, 93, 0.2)',
    'pill-warning-color': 'rgba(221, 194, 121, .65)',

    /**
     * Icons
     */
    'icon-notice-color': 'rgb(49, 53, 233)',
    'icon-warning-color': 'rgb(223, 176, 75)',
    'icon-error-color': 'rgb(251, 70, 70)',

    /**
     * Tables
     */
    'table-background': accents.accent1,
    'table-header-background': background,
    'table-header-color': accents.accent8,

    /**
     * Date Picker
     */
    'date-picker-alt-bg': '#232528',
    'date-picker-passive': accents.accent4,
    'time-picker-filter': 'invert(100%)',

    /**
     * Toast
     */
    'toast-background': '#07080a',
    'toast-color': accents.accent7,

    /**
     * Radio
     */
    'selected': accents.accent8,
  },

  input: {
    placeholder: accents.accent4,
    padding: '8px',
    tag: {
      background: accents.accent4,
    },
    focus: {
      borderColor: 'rgba(94, 30, 226, 1)',
      boxShadow: '0px 0px 0px 4px rgb(94 30 226 / 25%)',
      outlineWidth: '0',
    },
    invalid: {
      borderColor: 'rgb(206, 54, 92)',
      labelColor: 'rgb(206, 54, 92)',
    },
    invalidFocus: {
      borderColor: 'rgb(206, 54, 92)',
      boxShadow: '0px 0px 0 3px rgb(206 54 92 / 33%)',
    },
    readOnly: {
      background: accents.accent2,
    },
  },

  button: {
    mortal: {
      _base: {
        border: '1px solid',
      },
      secondary: {
        background: accents.accent1,
        borderColor: accents.accent2,
        color: accents.accent7,
      },
      primary: {
        'background': purples.purple5,
        'borderColor': purples.purple5,
        'color': 'white',
        ':disabled': {
          background: 'transparent',
          borderColor: accents.accent6,
          color: accents.accent7,
        },
        ':active': {
          background: purples.purple6,
        },
      },
      danger: {
        background: 'rgb(211, 81, 75)',
        borderColor: 'rgb(211, 81, 75)',
        color: 'white',
      },
      dark: {
        background: accents.accent1,
      },
    },

    ghost: {
      _base: {
        background: 'transparent',
        border: '1px solid transparent',
      },

      secondary: {
        'color': accents.accent7,

        '&:hover': {
          background: accents.accent1,
          borderColor: accents.accent1,
        },
      },

      primary: {
        'color': purples.purple5,

        '&:hover': {
          background: purples.purple8,
          borderColor: purples.purple8,
        },
      },

      danger: {
        'color': 'rgb(211, 81, 75)',

        '&:hover': {
          background: 'rgba(211, 81, 75, .1)',
          borderColor: 'rgba(211, 81, 75, .1)',
        },
      },
    },
  },
}

export default dark
